/**
 * Базовий URL API (завжди з суфіксом /api).
 * Docker: у weborderpicking_react задайте REACT_APP_API_URL=http://localhost:3571
 * або http://<IP-хоста>:3571 якщо заходите з телефона в локальній мережі.
 */
const resolveApiUrl = () => {
  const raw = typeof process !== 'undefined' && process.env.REACT_APP_API_URL
    ? String(process.env.REACT_APP_API_URL).trim().replace(/\/$/, '')
    : '';
  if (!raw) return 'http://192.168.50.123:3571/api';
  if (raw.endsWith('/api')) return raw;
  return `${raw}/api`;
};

export const config = {
    // apiUrl: resolveApiUrl(),
    apiUrl: 'https://order-picking.island-ukraine.com/api',
    uploadsUrl: 'https://order-picking.island-ukraine.com/uploads',
    logoImage: 'barcode-scan2.svg',
    scanCodeMin: 1,
    scanCodeMax: 500,
    scanPause: 2000,
    debugScan: true,
  };